import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { NormalLotteryMachineI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import { goldRewardAry, normalRewardAry, normalRewardNames } from "./LotteryConfig";
import LotteryMachine from "./LotteryMachine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LotteryResult extends cc.Component {

    @property({type:cc.Node,displayName:"center节点"})
    centerNode:cc.Node = null;

    @property({type:cc.Node,displayName:"球layout"})
    ballLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"按钮layout"})
    btnLayout:cc.Node = null;

    @property({type:cc.Node,displayName:"钱layout"})
    moneyLayout:cc.Node = null;

    @property({type:cc.Label,displayName:"金球数文本"})
    lb_goldNum:cc.Label = null;

    @property({type:cc.Label,displayName:"幸运数文本"})
    lb_luckyNum:cc.Label = null;

    @property({type:cc.Node,displayName:"未中奖节点"})
    notReWardTopNode:cc.Node = null;

    @property({type:cc.Node,displayName:"中奖节点"})
    reWardTopNode:cc.Node = null;

    @property({type:cc.Node,displayName:"叫花子节点"})
    jiaoReWardTopNode:cc.Node = null;
 
    @property({type:LotteryMachine,displayName:"彩票"})
    lottery:LotteryMachine = null;

    manager:NormalGameManager = null;
    
    onEnable(): void {
        this.manager = NormalGameManager._instance;
        this.openThis();
        this.canGetReward = true;
        this.updateDialog();
    }

    allMoney:number = 0;

    updateDialog(){
        let data = this.manager.getGameData().lotteryMachineData;

        let normalMoney:number = 0;

        let meSelectAry = data.meSelectAry;
        let rewardAry = data.winAry;
        let goldAry = data.goldAry;

        let normalRewardCount:number = 0;

        for(let i = 0;i<meSelectAry.length;i++){
            let me = meSelectAry[i];
            let ball = this.ballLayout.children[i];
            let ballh:cc.Node = ball.getChildByName("ball_h");
            let ballj:cc.Node = ball.getChildByName("ball_j");
            let ballb:cc.Node = ball.getChildByName("ball_b");
            let hLb:cc.Label = ballh.getChildByName("lb").getComponent(cc.Label);
            let jLb:cc.Label = ballj.getChildByName("lb").getComponent(cc.Label);
            let bLb:cc.Label = ballb.getChildByName("lb").getComponent(cc.Label);
            
            hLb.string = me.toString();
            jLb.string = me.toString();
            bLb.string = me.toString();

            ball.active = true;

            ballh.active = false;
            ballj.active = false;
            ballb.active = false;

            if(rewardAry.includes(me)){
                normalRewardCount ++;
                ballb.active = true;
            }else{
                ballh.active = true;
            }

            if(goldAry.includes(me)){
                ballh.active = false;
                ballb.active = false;    
                ballj.active = true;
            }
        }
        let name:string = "神秘奖";
        if(normalRewardCount == 0){
            // 没有中奖 判断是不是叫花子奖
            if(data.isConsolationPrize){
                // 是叫花子奖
                name = normalRewardNames[1];
                normalMoney = normalRewardAry[1];
            }else{
                // 不是叫花子奖
                name = normalRewardNames[0];
            }
        }else{
            // 中了奖
            normalMoney = normalRewardAry[normalRewardCount + 1];
            name = normalRewardNames[normalRewardCount + 1];
        }

        
        let goldMoney = goldRewardAry[goldAry.length];
        
        this.allMoney = normalMoney + goldMoney;
        
        this.lb_goldNum.string = goldAry.length.toString();
        this.lb_luckyNum.string = normalRewardCount.toString();

        this.moneyLayout.getChildByName("lb_Money").getComponent(cc.Label).string = data_control.getNumberFormat(this.allMoney);

        if(goldMoney > normalMoney){
            name = "神秘奖"
        }

        this.reWardTopNode.active = false;
        this.notReWardTopNode.active = false;
        this.jiaoReWardTopNode.active = false;

        this.btnLayout.children.forEach((n:cc.Node)=>{
            n.active = false;
        });

        if(name == normalRewardNames[0]){
            // 未中奖
            this.notReWardTopNode.active = true;
            this.btnLayout.children[2].active = true;
        }else if(name == normalRewardNames[1]){
            // 叫花子奖
            this.btnLayout.children[0].active = true;
            this.btnLayout.children[1].active = true;
            this.jiaoReWardTopNode.active = true;
        }else{
            // 其他奖
            this.btnLayout.children[0].active = true;
            this.btnLayout.children[1].active = true;
            this.reWardTopNode.active = true;
            let lb = this.reWardTopNode.getChildByName("lb").getComponent(cc.Label);
            lb.string = name;
        }
    }

    canGetReward:boolean = true;

    onBtnComit(){
        this.closeThis();
    }

    onBtnGet(e:cc.Event.EventTouch){
        if(this.canGetReward){
            let targetNode:cc.Node = e.target;
            this.closeThis();
            this.canGetReward = false;
            // console.log(this.allMoney,"多少钱？？？");
            O1HD.getServices().userSrv.setCoins(this.allMoney,true,targetNode);
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("已经领取过奖励");
        }
    }

    onBtnDouble(e:cc.Event.EventTouch){
        if(this.canGetReward){
            let targetNode:cc.Node = e.target;
            // console.log(this.allMoney,"多少钱？？？");
            utilsModel.loadAndShowVideoAdTrans(()=>{
                O1HD.getServices().userSrv.setCoins(this.allMoney * 2,true,targetNode);
                this.canGetReward = false;
                this.closeThis();
            },()=>{
    
            },null,"双色球看视频获取双倍奖励");
        }else{
            O1HD.getModules().uiControlModule.showMessageBox("已经领取过奖励");
        }
    }

    openThis(){
        // this.centerNode.scale = 0;
        // cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    closeThis(){
        this.manager.getGameData().lotteryMachineData = <NormalLotteryMachineI>{};
        this.manager.writeGameData();
        // cc.tween(this.centerNode).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
        this.lottery.resultEnd();
        // this.scheduleOnce(()=>{
            this.node.active = false;
        // },.5);
    }

}
